import React from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { ForgotPassword } from 'api/mutations'
import { useMutation } from 'react-query'

import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { ROUTES } from 'routes'

const schema = yup.object().shape({
  email: yup.string().email().required()
})

const ForgotPasswordPage = (props) => {

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema)
  })
  const mutation = useMutation(ForgotPassword)

  const onSubmit = async data => {
    await mutation.mutateAsync({email: data.email, numeric: true})

    props.history.push(ROUTES.HOME)
  }
  return (
    <div className='c-app c-default-layout flex-row align-items-center'>
      <CContainer>
        <CRow className='justify-content-center'>
          <CCol md='6'>
            <CCardGroup>
              <CCard className='p-4'>
                <CCardBody>
                  <CForm onSubmit={handleSubmit(onSubmit)}>
                    <h1>Forgot Password</h1>
                    <p className='text-muted'>Enter your email to receive reset password instructions</p>
                    <CInputGroup className='mb-3'>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name='cil-user' />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput type='email' placeholder='Email' name='email' id='email' innerRef={register} />
                    </CInputGroup>
                    <p>{errors.email?.message}</p>
                    <CRow>
                      <CCol xs='6'>
                        <CButton color='primary' type='submit' className='px-4'>Send instructions</CButton>
                      </CCol>
                      <CCol xs='6' className='text-right'>
                        <Link to={ROUTES.LOGIN} color='link' className='px-0'>Login</Link>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default ForgotPasswordPage
